import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { Typography, ListItem, Radio, ListItemIcon, ListItemText } from '@material-ui/core';
import { SortByList as sortbylist } from '../../constants/sortByList';
import styles from './styles';

const SortByList = ({ t, classes }) => (
  <React.Fragment>
    <div className={classes.scroll__wheel}>
      {sortbylist.map(list => (
        <ListItem className={classes.item__container}>
          <ListItemIcon>
            <img src={list.icon} alt={list.name} className={classes.icons} />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography className={classes.title}>{t(`sort-by.label.${list.name}`)}</Typography>
            }
            secondary={
              <Typography className={classes.subtitle}>
                {t(`sort-by.label.${list.sortby}`)}
              </Typography>
            }
          />
          <Radio
            color="default"
            classes={{
              root: classes.unchecked__button,
            }}
          />
        </ListItem>
      ))}
    </div>
    <div className={classes.overlay} />
  </React.Fragment>
);

SortByList.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default withTranslation()(
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(SortByList),
  ),
);
